<template>
	<div class="search">
		<div class="banner"></div>
		<div class="navList">
			<div class="w1200 clearfix">
				<div class="topDh">
					<!-- 当前位置 -->
					<address-bar :addressBarData="Nav"></address-bar>
				</div>
				<div class="main">
					<div id="infoBox">
						<no-img-List :dataList= 'List'></no-img-List>
						<page-box :pageBoxData="List.PageBar" :pageIndex="PageIndex"></page-box>
						<!-- <div v-if="!List.PageBar">
							<p style="text-align: center;" class="jieguo">暂无搜索结果</p>
						</div>
						<div v-else>
							<no-img-List :noImgList = "List" ></no-img-List> -->
							<!-- 分页 -->
							<!-- <page-box :pageBoxData="List.PageBar" :pageIndex="PageIndex"></page-box>
						</div> -->
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import '../assets/css/list.css';
	import addressBar from '@/components/addressBar';
	import pageBox from '@/components/pageBox';
	import noImgList from '@/components/noImgList2';
	export default{
		name:'search',
		components:{
			addressBar,
			pageBox,
			noImgList
		},
		data(){
			return{
				selText:this.$route.query.selText,
			    PageIndex:this.$route.query.PageIndex,
			    item:'',
			    List:[],
			    Nav: {
				    PColumn: { Name: "搜索", Url: "javascript:;" },
				    lanmu: {Name: "搜索结果",Url: "javascript:;"},
				List:[{
				    Name: '搜索结果',
				    Url: "javascript:;"
				}]
			   }
			}
		},
		created(){
		    this.List = this.Base.GetInfoBySearch(this.selText,this.PageIndex,6);  
			console.log(this.List,'搜索')
		},
		methods:{
			
		}
	}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/search.vue